import { sendSms, type SendSmsRequest } from '@/remote/sms/send-sms';
import { useMutation } from '@tanstack/react-query';
import { toast } from './use-toast';

export const useSendSms = () => {
  return useMutation({
    mutationFn: (data: SendSmsRequest) => sendSms(data),
    onSuccess: (data) => {
      if (data.success) {
        toast({
          title: '문자 발송 성공',
          description: '문자가 성공적으로 발송되었습니다.',
          variant: 'default',
        });
      }
    },
    onError: (error: Error) => {
      const errorMessage = error.message || '문자 발송에 실패했습니다.';
      toast({
        title: '문자 발송 실패',
        description: errorMessage,
        variant: 'destructive',
      });
    },
  });
};
